/* eslint-disable */

export const CHECKBOX_ITEMS = [
    "I'm taking a break, but I'll be back",
    "The tool is great, but I don't need it anymore",
    "It's missing features I need. (Please specify below)",
    "I'm consolidating with another account",
    'I had too many technical/product issues. (Please specify below)',
    'I found another product I like more',
    "I would use it if it wasn't so hard/confusing to use. (Please specify below)",
    "It's above our budget",
    'I was just trying the tool!',
    'Other (Please specify below)',
];
